import _ from 'lodash';
import Home from '../views/Home.vue';
import SignIn from '../views/SignIn.vue';

let routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    name: 'SignIn',
    path: '/login',
    component: SignIn,
  },
  {
    path: '/users/',
    name: 'users',
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "users.index" */

        '../views/users/UsersIndex.vue'
      ),
    children: [
      {
        path: 'list',
        name: 'users.list',
        component: () =>
          import(
            /* webpackChunkName: "users.list" */

            '../views/users/UsersList.vue'
          ),
      },
      {
        path: 'show/:uuid',
        name: 'users.show',
        component: () =>
          import(
            /* webpackChunkName: "users.show" */

            '../views/users/UsersShow.vue'
          ),
      },
    ],
  },
  {
    path: '/porperty/',
    name: 'porperty',
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "property.index" */

        '../views/property/PropertyIndex.vue'
      ),
    children: [
      {
        path: 'list',
        name: 'property.list',
        component: () =>
          import(
            /* webpackChunkName: "property.list" */

            '../views/property/PropertyList.vue'
          ),
      },
      {
        path: 'show/:uuid',
        name: 'property.show',
        component: () =>
          import(
            /* webpackChunkName: "property.show" */

            '../views/property/PropertyShow.vue'
          ),
      },
    ],
  },
  {
    path: '/preference/',
    name: 'preference',
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "preference.index" */

        '../views/preferences/PreferencesIndex.vue'
      ),
    children: [
      {
        path: 'list',
        name: 'preference.list',
        component: () =>
          import(
            /* webpackChunkName: "preference.list" */

            '../views/preferences/PreferencesList.vue'
          ),
      },
      {
        path: 'show/:uuid',
        name: 'preference.show',
        component: () =>
          import(
            /* webpackChunkName: "preference.show" */

            '../views/preferences/PreferenceShow.vue'
          ),
      },
    ],
  },
  {
    path: '/message/',
    name: 'message',
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "message.index" */

        '../views/message/MessageIndex.vue'
      ),
    children: [
      {
        path: 'list',
        name: 'message.list',
        component: () =>
          import(
            /* webpackChunkName: "message.list" */

            '../views/message/MessageList.vue'
          ),
      },
      {
        path: 'show/:uuid',
        name: 'message.show',
        component: () =>
          import(
            /* webpackChunkName: "message.show" */

            '../views/message/MessageShow.vue'
          ),
      },
    ],
  },
];

export default routes;
